import React, { useState } from 'react';

import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import particlesConfig from '../Shared/pr-s-black';
import { API_ENDPOINTS } from '../config/api';

const particlesInit = async (engine) => {
  await loadSlim(engine);
};

const particlesLoaded = async (container) => {
};

export default function Contact() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // { type: 'success' | 'error', message: string }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    
    try {
      const response = await fetch(API_ENDPOINTS.contact, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });
      
      const data = await response.json();
      
      if (data.success) {
        setSubmitStatus({ 
          type: 'success', 
          message: 'Thank you! We\'ll be in touch soon.' 
        });
        // Clear form on success
        setFormData({ firstName: '', lastName: '', email: '', message: '' });
      } else {
        setSubmitStatus({ 
          type: 'error', 
          message: data.error || 'Something went wrong. Please try again.' 
        });
      }
    } catch (error) {
      console.error('Contact form error:', error);
      setSubmitStatus({ 
        type: 'error', 
        message: 'Network error. Please check your connection and try again.' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div id="contact-page">
      <section className="contact-header">
        <div className="particles circle-bg">
          <div className="container">
            <div className="title-box">
              <h1>
                <span className="color-font">READY TO TAKE YOUR BRAND</span>
              </h1>
              <h1>
                <span className="color-font">TO THE </span>
                <span className="highlight-font">NEXT LEVEL</span>
                <span className="color-font">?</span>
              </h1>
            </div>
          </div>
          
          <Particles id="particles-js" init={particlesInit} loaded={particlesLoaded} options={particlesConfig} />
          
          <div className="gradient-circle"></div>
          <div className="gradient-circle two"></div>
        </div>
      </section>
      
      <section className="contact-section">
        <div className="container">
          <h2>CONTACT US TODAY!</h2>

          <p style={{ textAlign: 'center', opacity: 0.85, marginBottom: 24 }}>
            Prefer email? Reach us at{' '}
            <a href="mailto:support@trnd.co" style={{ color: 'inherit', textDecoration: 'underline' }}>support@trnd.co</a>.
            We are a Canadian company and typically reply within one business day.
          </p>

          <div className="contact-form-container">
            <form onSubmit={handleSubmit}>
              <div className="form-group name-group">
                <label>Name <span className="required">*</span></label>
                <div className="name-inputs">
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="First Name"
                    required
                  />
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Last Name"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="email">Email <span className="required">*</span></label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="your@email.com"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message <span className="required">*</span></label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your project..."
                  required
                />
              </div>

              {submitStatus && (
                <div className={`form-status ${submitStatus.type}`}>
                  {submitStatus.message}
                </div>
              )}

              <div className="submit-container">
                <button 
                  type="submit" 
                  className="contact-submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Submit'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
